"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapWithProviders = void 0;

var _currentVariantState = require("@phx-husky/current-variant-state");

var _screenRecognition = require("@phx-husky/screen-recognition");

var _react = _interopRequireDefault(require("react"));

var _ExternalLinkDialogContext = _interopRequireDefault(require("~/context/ExternalLinkDialogContext"));

const wrapWithProviders = ({
  element
}) => /*#__PURE__*/_react.default.createElement(_screenRecognition.ScreenRecognitionProvider, null, /*#__PURE__*/_react.default.createElement(_currentVariantState.CurrentVariantStateProvider, null, /*#__PURE__*/_react.default.createElement(_ExternalLinkDialogContext.default, null, element)));

exports.wrapWithProviders = wrapWithProviders;